// "Spot the Slip" expansion — HOUSE & HOME theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_HOUSE = [
  ["La cocina es muy sucia esta mañana.", "La cocina está muy sucia esta mañana.", "ser-estar",
    "A condition you can change (dirty right now) takes estar.", "ser-vs-estar"],
  ["El sótano es húmedo desde la tormenta.", "El sótano está húmedo desde la tormenta.", "ser-estar",
    "A resulting state after rain uses estar.", "ser-vs-estar"],
  ["¿Dónde es el baño?", "¿Dónde está el baño?", "ser-estar",
    "Location of a place is always estar.", "ser-vs-estar"],
  ["El salón es muy espacioso y luminoso.", "El salón es muy espacioso y luminoso.", "ser-estar",
    "Trap check: an inherent feature of the room is ser. (Already correct!)", "ser-vs-estar"],
  ["Tengo un habitación pequeña.", "Tengo una habitación pequeña.", "gender",
    "Habitación is feminine → una.", "gender-agreement-of-nouns"],
  ["La pared blanco es nueva.", "La pared blanca es nueva.", "gender",
    "Pared is feminine; the adjective is blanca.", "adjective-agreement"],
  ["El alfombra es muy suave.", "La alfombra es muy suave.", "gender",
    "Alfombra is feminine → la.", "gender-agreement-of-nouns"],
  ["Me gusta las cortinas nuevas.", "Me gustan las cortinas nuevas.", "gustar",
    "Plural curtains → gustan.", "gustar-and-similar-verbs"],
  ["Pagué la fianza para el piso, mil euros para dos meses.", "Pagué la fianza por el piso, mil euros por dos meses.", "por-para",
    "An exchange (money for something) is por.", "por-vs-para"],
  ["Necesito una llave para abrir el cajón.", "Necesito una llave para abrir el cajón.", "por-para",
    "Trap check: purpose ('in order to open') correctly uses para. (Already correct!)", "por-vs-para"],
  ["¿El grifo? Lo arreglé esta mañana, le llamé al casero.", "¿El grifo? Lo arreglé esta mañana y se lo dije al casero.", "pronoun-order",
    "le + lo becomes se lo; you can't say 'le lo'.", "object-pronouns"],
  ["Ayer limpiaba toda la casa en dos horas.", "Ayer limpié toda la casa en dos horas.", "preterito-imperfecto",
    "A single, finished action in a set time takes the pretérito.", "a2-preterito-vs-imperfecto"],
  ["El sotano está debajo de la cocina.", "El sótano está debajo de la cocina.", "accents",
    "Sótano is esdrújula, so it always carries a written accent.", "stress-and-written-accents"],
  ["Es importante que la casa tiene buena calefacción.", "Es importante que la casa tenga buena calefacción.", "subjunctive",
    "Impersonal 'es importante que' takes the subjunctive → tenga.", "b1-present-subjunctive"],
  ["Busco un piso que es espacioso y barato.", "Busco un piso que sea espacioso y barato.", "subjunctive",
    "An as-yet-unknown thing you're searching for triggers the subjunctive → sea.", "b1-present-subjunctive"],
];
